import { pyament, postPayloadBK, finalBgReUpload, ZeroFeeBgUpload } from "@config/apiEndPoints";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const paymentThunk = createAsyncThunk(
  "payment",
  async (id: any, thunkAPI) => {
    try {
      const response = await pyament(id);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || error.message || "Payment failed"
      );
    }
  }
);

export const postPayloadBkpayThunk = createAsyncThunk(
    "payment/postPayloadBkpayThunk",
    async (payload: any, { rejectWithValue }) => {
      try {
        const response = await postPayloadBK(payload);
        return response.data;
      } catch (error: any) {
        return rejectWithValue(
          error.response?.data || error.message || "Failed data is not loaded"
        );
      }
    }
  );

  export const postFinalBgReUploadThunk = createAsyncThunk(
    "payment/postFinalBgReUploadThunk",
    async (payload: any, { rejectWithValue }) => {
      try {
        const response = await finalBgReUpload(payload);
        return response.data;
      } catch (error: any) {
        return rejectWithValue(
          error.response?.data || error.message || "Failed data is not loaded"
        );
      }
    }
  );


export const ZeroFeeBgUploadThunk = createAsyncThunk( 
  "payment/ZeroFeeBgUploadThunk",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await ZeroFeeBgUpload(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || error.message || "Failed data is not loaded"
      );
    }
  }
);